

import React, { useContext } from "react"
import { Accordion, AccordionSummary, AccordionDetails } from "@material-ui/core"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FlexView from "react-flexview/lib"
import { InsurancePurchaseContextStore } from "../../../context/InsuracePurchaseContext";
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import { FirebaseService, FirebaseConfigKey } from "../../../services/FirebaseService";
import { InsuranceBillingPeriod } from "../../../models/insurance-models/InsuranceBillingPeriodModel";
import { isCanada } from '../../../services/utils';

export const WhatsCoveredSummarySection = (isFleetPortal = false) => {
 
    const insuranceContext = useContext(InsurancePurchaseContextStore)
    if (!FirebaseService.getBoolean(FirebaseConfigKey.WHATS_COVERED_AVAILABLE)){
        return (null);
    }

    const covered = [
        {title: 'Aviation Liability, including Property Damage and Bodily Injury', covered: true},
        {title: 'Personal and Advertising Injury claims, including certain Privacy claims', covered: true},
        {title: 'Indoor Coverage', covered: true},
    ]
    if(!isCanada()){
        covered.push({title: 'Worldwide Coverage', covered: true})
    }
    if(isFleetPortal){
        covered.push({title: 'Medical Expense', covered: true})
        covered.push({title: 'Personal Injury', covered: true})
    }
    covered.push({title: 'Damage to the drone body', covered: insuranceContext.drones.length > 0 || insuranceContext.selectedOption.dronePremium > 0})

    return (
        <Accordion elevation={0} className="summary-expansion transparent">
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FlexView className="space-between full-width">
                    <div className="text-body gray">What's covered?</div>
                    <div className="text-body gray">Read more</div>
                </FlexView>
            </AccordionSummary>
            <AccordionDetails>
                <ul>
                    {covered.map((item, index) => <FlexView vAlignContent={'center'} key={index} className="text-small margin-top-small black">
                     {item.covered ? <DoneIcon className="margin-right-6 green"/> : <ClearIcon fontSize="small" className="margin-right-6 red"/>} {item.title}
                    </FlexView>)}
                </ul>
            </AccordionDetails>
        </Accordion>
    )
}